import InsuranceTypeBox from '../insurance-type-box/insurance-type-box.component';
import UnitedStatesImage from '../../assets/images/img-destino-01.webp';
import CruiseImage from '../../assets/images/img-destino-02.webp';
import BrazilImage from '../../assets/images/img-destino-03.webp';
import ParisImage from '../../assets/images/img-destino-04.webp';
import { useTheme, Box, Typography } from '@mui/material';

const InsuranceTypesGrid = () => {
  const buildInsuranceTypeUrl = (destination) =>
    `/trip-ensurance?${new URLSearchParams({ destination })}`;

  const insuranceTypes = [
    {
      id: 1,
      imageUrl: UnitedStatesImage,
      title: 'Estados Unidos',
      text: 'Explore todos os cantos dos Estados Unidos sem se preocupar com nada e economize na sua viagem com total segurança.',
      url: buildInsuranceTypeUrl('América do Norte'),
    },
    {
      id: 2,
      imageUrl: CruiseImage,
      title: 'Cruzeiro',
      text: 'Tenha uma viagem inesquecível a bordo de um cruzeiro, sem preocupações e com economia garantida.',
      url: '/trip-ensurance',
    },
    {
      id: 3,
      imageUrl: BrazilImage,
      title: 'América do Sul',
      text: 'Descubra as maravilhas da América do Sul sem nenhuma preocupação e com o melhor preço.',
      url: buildInsuranceTypeUrl('América do Sul'),
    },
    {
      id: 4,
      imageUrl: ParisImage,
      title: 'Europa',
      text: 'Encontre o seguro que atenda todas exigências dos países Europeus e que tenha o melhor preço.',
      url: buildInsuranceTypeUrl('Europa'),
    },
  ];

  const theme = useTheme();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          backgroundColor: `${theme.palette.primary.contrastText}`,
          borderRadius: `${theme.spacingValues.large}`,
          padding: `${theme.spacingValues.small} ${theme.spacingValues.medium}`,
          width: 'fit-content',
        }}
      >
        <Typography sx={{ color: `${theme.palette.primary.main}` }}>
          Destino
        </Typography>
      </Box>
      <Typography variant="h3" my={'1rem'}>
        Escolha o{' '}
        <span style={{ color: theme.palette.primary.main }}>seu destino</span>
      </Typography>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: '1fr',
            sm: 'repeat(2, 1fr)',
          },
          gap: theme.spacingValues.medium,
          maxWidth: 'lg',
          mx: 'auto',
          px: theme.spacingValues.medium,
          py: theme.spacingValues.medium,
        }}
      >
        {insuranceTypes.map((insuranceType) => (
          <InsuranceTypeBox
            key={insuranceType.id}
            insuranceType={insuranceType}
          />
        ))}
      </Box>
    </Box>
  );
};

export default InsuranceTypesGrid;
